export const projects = [
  {
    name: "Saldy",
    description: "Ett modernt bokföringsprogram för småföretag.",
    img: "/images/projects/saldy.png",
    url: "https://www.saldy.se/",
  },
  {
    name: "Aiuli",
    description: "En smart plattform som hjälper resenärer att planera multi-city resor och optimera sina stopp.",
    img: "/images/projects/AiuliMain.webp",
    url: "https://aiuli.com",
  },
  {
    name: "Go Sing Girl",
    description: "Ett partyspel där spelare sjunger och gissar låtar – perfekt för spelkvällar och förfester.",
    img: "/images/projects/goSingGirl.webp",
    url: "https://gosinggirl.com",
  },
  {
    name: "Beautyshelfhub",
    description: "En blogg med skönhetstips och recensioner, byggd med SEO för att driva organisk trafik.",
    img: "/images/projects/BSH.webp",
    url: "https://beautyshelfhub.com",
  },
  {
    name: "Clap Count",
    description: "En tracking-app med statistik och gamification, designad för att göra uppföljning roligare.",
    url: "https://clapcount.com",
    img: "/images/projects/ClapCount.webp",
  },
  {
    name: "Dataeden.se",
    description: "Vår egna hemsida, skapad för att hjälpa företag med modern webbutveckling och SEO.",
    img: "/images/projects/dataeden.png",
    url: "https://dataeden.se",
  },
  {
    name: "Padelmaster - Appen",
    description:
      "iOS och Android-app till Padelmaster, världens bästa bollmaskin för padel, som hjälper dig att ta ditt spel till nästa nivå.",
    img: "/images/projects/padelmaster.webp",
    url: "https://padelmaster.io/",
  },
  {
    name: "Kandidatkollen",
    description:
      "En AI-driven plattform för att snabbt och effektivt screena och rangordna CV:n, så att du hittar rätt kandidat på minuter.",
    img: "/images/projects/kandidatkollen.png",
    url: "https://kandidatkollen.se/",
  },
  {
    name: "Rank Lush",
    description:
      "Ett SEO-verktyg som hjälper webbplatsägare att analysera och förbättra sin sökmotoroptimering, så att de kan klättra i sökresultaten och driva mer organisk trafik.",
    img: "/images/projects/ranklush.png",
    url: "https://ranklush.com/",
  },
];
